<script setup lang="ts">
import type { DropdownItem } from '#ui/types'

const { enabled: pulseFeaturesEnabled } = useFlag('PULSE_FEATURES')
const { enabled: sleuthSkillsEnabled } = useFlag('SLEUTH_SKILLS')

const isRepositoryModalOpen = ref(false)
const isTeamModalOpen = ref(false)

const showDropdown = computed(() => {
  const enabledCount = [pulseFeaturesEnabled.value, sleuthSkillsEnabled.value].filter(Boolean).length
  return enabledCount > 1 || (sleuthSkillsEnabled.value && !pulseFeaturesEnabled.value)
})

const newDropdownItems = computed(() => {
  const items: DropdownItem[][] = []
  const group: DropdownItem[] = []

  if (pulseFeaturesEnabled.value) {
    group.push({
      label: 'Teamspace',
      icon: 'light:folder',
      click: () => navigateTo({ name: 'teamspace-new' }),
    })
  }

  if (sleuthSkillsEnabled.value) {
    group.push({
      label: 'Repository',
      icon: 'light:code',
      click: () => { isRepositoryModalOpen.value = true },
    })
    group.push({
      label: 'Team',
      icon: 'light:users',
      click: () => { isTeamModalOpen.value = true },
    })
  }

  if (group.length > 0) {
    items.push(group)
  }

  return items
})
</script>

<template>
  <div class="px-2">
    <UDropdown
      v-if="showDropdown"
      :items="newDropdownItems"
      :popper="{ placement: 'bottom-start' }"
      class="w-full"
    >
      <UButton
        icon="light:plus"
        data-action="new-button"
        data-tour="new-button"
        color="white-nav"
        label="Create"
        variant="ghost"
        class="mb-px flex flex-1 items-center justify-start px-2"
        block
      >
        <template #trailing>
          <div class="flex flex-1 justify-end">
            <UIcon name="solid:angle-down" class="size-3" />
          </div>
        </template>
      </UButton>
      <template #item="{ item }">
        <div class="flex gap-1.5">
          <UIcon :name="item.icon" class="size-4" />
          <span>{{ item.label }}</span>
        </div>
      </template>
    </UDropdown>
    <UButton
      v-else
      icon="light:plus"
      data-action="new-teamspace-button"
      data-tour="new-teamspace-button"
      color="white-nav"
      label="New teamspace"
      variant="ghost"
      class="mb-px flex flex-1 items-center justify-start px-2"
      block
      :ui="{ block: 'justify-start' }"
      :to="{ name: 'teamspace-new' }"
    />
  </div>

  <NavigationCreateRepositoryModal v-model="isRepositoryModalOpen" />
  <NavigationCreateTeamModal v-model="isTeamModalOpen" />
</template>
